<template>
  <div id="photo-check">
    <v-container class="pa-0">
      <v-layout row wrap>

        <div class="padding-15-no-bottom background-white">
          <h1 v-if="scanning">{{ scanning_title }}</h1>
          <h1 v-if="!scanning && !hasApiError && !valid">{{ error_title }}</h1>
          <h1 v-if="!scanning && !hasApiError && valid">{{ ok_title }}</h1>
          <h2 v-if="hasApiError">Fout bij het scannen</h2>
        </div>
        <v-card class="pa-0" flat color="#ffffff">
          <v-card-text style="padding: 30px 20px 0px 40px!important;">
            <div v-if="scanning" v-html="scanning_content"></div>
            <!--<div v-if="!scanning && !hasApiError && !valid" v-html="error_content"></div>-->
            <div v-if="!scanning && !hasApiError && valid" v-html="ok_content"></div>
            <div v-if="hasApiError">
              Er heeft zich een fout voorgedaan tijdens het scannen. Onze excuses voor het ongemak!
              <br>
              <br>
              <div style="text-align:center">
                <v-btn depressed dark color="#e32219" @click="$router.go()">Opnieuw proberen</v-btn>
              </div>
            </div>
          </v-card-text>
        </v-card>

        <v-flex xs12 v-if="!showErrors && !hasApiError">
          <div id=wrapper class="scanner-wrapper">
            <div id="overlay" :class="{'has-errors':!valid}">
              <v-progress-circular
                  v-show="scanning"
                  indeterminate
                  color="white"
                  :width="7"
                  :size="100"
              >We controleren je foto!
              </v-progress-circular>
              <v-icon size=96 color="white" v-if="!scanning && valid">check</v-icon>
              <v-icon size=96 color="white" v-if="!scanning && !valid">close</v-icon>
            </div>
            <v-img :src="imageUrl" height="40vh" contain v-bind:class="{loading:scanning}"></v-img>
          </div>
        </v-flex>


        <v-flex xs12 v-if="showErrors && !hasApiError">
          <div class="errors">
            <div class="padding-around-progress">
            <v-progress-linear
                v-model="progress"
                height="15"
                class="rounded-progress"
                color="accent"
            ></v-progress-linear>
            </div>
            <v-tabs
                v-model="currentError"
                show-arrows
                dark
                ref="errors"
                style="padding-bottom: 100px;"
            >

              <v-tab
                  v-for="error in photo_errors"
                  :key="error.id"
                  ripple
              >{{ error.description }}
              </v-tab>
              <v-tab-item
                  v-for="error in photo_errors"
                  :key="error.id"
              >
                <v-layout row wrap>
                  <v-flex xs12>
                    <v-card class="pa-0" flat color="#EDEFF0">
                      <v-card-text style="text-align: center;">
                        <h3>{{ error.description }}</h3>
                        <br>
                        <div v-html="error.long_message"></div>
                        <v-img :src="imageUrl" height="200" class="mb-3" contain v-bind:class="{loading:scanning}"></v-img>
                        <v-btn v-if="!valid" round dark color="#EE1D25" @click="$router.push('/photo')" class="v-btn__go-back"><i class="rotate-90 icon icon-kruidvat-arrow icon-white"></i> Nieuwe foto maken</v-btn>
                      </v-card-text>
                    </v-card>
                  </v-flex>
                </v-layout>
              </v-tab-item>
            </v-tabs>
          </div>
        </v-flex>
      </v-layout>

    </v-container>



    <v-footer ref="footer" fixed color="white" class="background-white" height="auto">
      <v-container class="pa-0" fluid style="padding-top: 0">

        <!-- photo order buttons --->
        <v-layout row wrap>
          <v-flex xs12>
            <v-btn block color="#2E4278" class="v-btn__use-photo" dark @click="toggleErrors" v-if="!scanning && !hasApiError && !valid && !showErrors">Laat fouten zien</v-btn>
            <v-btn block color="#2E4278" class="v-btn__use-photo" dark @click="submitOrder" v-if="!scanning && !hasApiError && valid">Direct bestellen voor &euro; 3,95!</v-btn>
          </v-flex>
          <v-flex xs12>
            &nbsp;
          </v-flex>
        </v-layout>

        <!--- OR: error slide buttons -->
        <v-layout row wrap v-if="showErrors">
          <v-flex :xs5="hasNextError" :xs12="!hasNextError" v-if="hasPrevError">
            <v-btn  block color="blue" dark class="v-btn--prev--next" @click="prevError"><i class="rotate-90 icon icon-kruidvat-arrow icon-white"></i> Vorige</v-btn>
          </v-flex>
          <v-flex :xs7="hasPrevError" :xs12="!hasPrevError" v-if="hasNextError">
            <v-btn  block color="blue" dark class="v-btn--prev--next" @click="nextError">Volgende <i class="icon icon-kruidvat-arrow icon-white"></i></v-btn>
          </v-flex>
          <v-flex xs12>
            &nbsp;
          </v-flex>
        </v-layout>

      </v-container>
    </v-footer>



  </div>
</template>

<script>
  import BackendService from "@/services/BackendService";

  export default {
    name: 'check',
    data() {
      return {
        scanning_title: '',
        scanning_content: '',
        ok_title: '',
        ok_content: '',
        error_title: '',
        error_content: '',
        scanning: true,
        showErrors: false,
        currentError: 0,
        photo_errors: {},
        imageUrl: '',
        hasApiError: false
      }
    },
    mounted() {
      this.showPreview();
      this.checkPhoto();
    },
    created() {
      this.getText();
    },
    computed: {
      valid: function () {
        return this.photo_errors.length === 0;
      },
      hasNextError: function() {
        return this.currentError + 1 < this.photo_errors.length;
      },
      hasPrevError: function() {
        return this.currentError > 0;
      },
      progress: function() {
        return Math.round(((this.currentError+1) / this.photo_errors.length) * 100);
      }
    },
    methods: {
      getText() {
        BackendService.getText(16)
          .then((response) => {
            this.scanning_title = response.data.title;
            this.scanning_content = response.data.content;
          });
        BackendService.getText(17)
          .then((response) => {
            this.error_title = response.data.title;
            this.error_content = response.data.content;
          });
        BackendService.getText(18)
          .then((response) => {
            this.ok_title = response.data.title;
            this.ok_content = response.data.content;
          });
      },
      showPreview() {
        let token = localStorage.accessToken;
        let key = localStorage.photoKey;
        this.imageUrl = process.env.VUE_APP_API_URL + '/photo/preview/' + key + '?token=' + token;
      },
      toggleErrors() {
        this.showErrors = !this.showErrors;
      },
      nextError() {
        if (this.currentError < this.photo_errors.length) {
          this.currentError = this.currentError + 1;
        }
      },
      prevError() {
        if (this.currentError > 0) {
          this.currentError = this.currentError - 1;
        }
      },
      checkPhoto() {
        // doe de API
        // timeout = setTimeout(() => { this.scanning = false; } , 1000);
        let token = localStorage.accessToken;
        let key = localStorage.photoKey;
        BackendService.getPhotoErrors(key,token)
          .then((response) => {
            this.scanning = false;
            this.photo_errors = response.data.errors;
            this.imageUrl = process.env.VUE_APP_API_URL + '/photo/preview/' + key + '?token=' + token + '&t=' + Date.now();
          })
          .catch((error) => {
            this.scanning = false;
            this.valid = false;
            this.hasApiError = true;
            // console.log(error);
          })
      },
      submitOrder() {
        if (this.valid) {
          this.$router.push('/order');
        }
      },
    },
  };
</script>

<style scoped>

  body {
    background-color: #F0F0F0;
  }

  #camera {
    /*text-align: center;*/
    /*color: #2c3e50;*/
    /*margin-top: 60px;*/
  }

  #wrapper-background {
    background: #000;
  }


  .errors li {
    display: list-item;
  }

  /*#errors-face {*/
    /*width: 200px;*/
    /*height: 300px;*/
    /*margin-left: -100px;*/
    /*margin-top: -150px;*/
    /*left: 50%;*/
    /*top: 50%;*/
  /*}*/

  #wrapper {
    position: relative;
    overflow: hidden;
    margin: 0 auto;
  }

  #overlay {
    position: absolute;
    top: 50%;
    margin-top: -30px;
    text-align: center;
    z-index: 2;
    width: 90%;
    left: 5%;
  }


  li {
    display: inline;
    padding: 5px;
  }

  video {
    background: #000;
    object-fit: cover;
  }
</style>
